import Spacer from "@p-ban/common/src/components/layout/Spacer"
import SEMINAR_STATUS from "@p-ban/core/src/seminar/constant/SEMINAR_STATUS"

import MyPageTheme from "../../../components/mypage/MyPageTheme"
import Text from "../../../components/ui/Text/Text"
import type { SeminarValues } from "../api/seminarApi"
import SeminarSummary from "../components/SeminarSummary"

const SeminarEntryInvalid = ({ seminar }: { seminar?: SeminarValues }) => {
  if (seminar && SEMINAR_STATUS[seminar.seminarStatus].isPublished) {
    return (
      <MyPageTheme>
        <SeminarSummary seminar={seminar} />
        <Spacer size={40} />
        <Text>
          {seminar.seminarStatus === SEMINAR_STATUS.AcceptEnd.value &&
            "申し訳ございません。ご指定のセミナーの受付は終了いたしました。"}
          {seminar.seminarStatus === SEMINAR_STATUS.End.value &&
            "申し訳ございません。ご指定のセミナーは終了いたしました。"}
        </Text>
      </MyPageTheme>
    )
  }
  return (
    <MyPageTheme>
      <Spacer size={40} />
      <Text>ご指定のセミナーは存在いたしません。</Text>
    </MyPageTheme>
  )
}

export default SeminarEntryInvalid
